import { Skeleton } from 'antd';
import { Controller, useWatch } from 'react-hook-form';
import { CreateTicketFormValues } from '../../../../../../../../types/form';
import CustomField from '../../../../../../../components/CustomField';
import useAgentFormById from '../../../../../../../hooks/ticketDetailPage/useAgentFormById';
import useFieldDefinitionByKey from '../../../../../../../hooks/ticketDetailPage/useFieldDefinitionByKey';
import {
    TICKET_FORM_FIELDS_KEY,
    TicketSystemFieldsKey,
    TicketSystemFieldsKeyMap
} from '../../../../../../../model/types';
import { getFieldRuleByKey } from '../../../../../../../utils/forms/formHelper.util';
import { getValidationRules } from '../../../../../../../utils/forms/formHelper.validators';
import { FORM_FIELD_KEY, generateReactHookFormFriendlyFieldName } from '../../../AgentFormActiveFieldsContainer';

const CreateTicketSubjectContainer = (): JSX.Element => {
    const formId = useWatch<CreateTicketFormValues, typeof FORM_FIELD_KEY>({ name: FORM_FIELD_KEY });
    const currentAgentForm = useAgentFormById(Number(formId));
    const subjectFieldDefinition = useFieldDefinitionByKey(TicketSystemFieldsKey.subject);

    if (!subjectFieldDefinition) return <Skeleton.Input active className="full-width" />;

    const fieldRuleOnForm = currentAgentForm?.fields?.find(getFieldRuleByKey(subjectFieldDefinition));

    return (
        <Controller<
            CreateTicketFormValues,
            `${typeof TICKET_FORM_FIELDS_KEY}.${typeof TicketSystemFieldsKeyMap.subject}`
        >
            name={generateReactHookFormFriendlyFieldName(subjectFieldDefinition.key)}
            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <>
                    <CustomField
                        containerProps={{
                            errorMessage: error?.message,
                            fieldRequirement: fieldRuleOnForm?.required || subjectFieldDefinition?.required
                        }}
                        fieldDefinition={subjectFieldDefinition}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                    />
                </>
            )}
            rules={{
                validate: getValidationRules({
                    fieldRuleOnForm,
                    fieldDefinition: subjectFieldDefinition
                })
            }}
        />
    );
};

export default CreateTicketSubjectContainer;
